module.exports = __webpack_public_path__ + "img/risk.3a2dcac2.svg";